import S, { DataSignal } from 's-js';

import { ActivityFeed, ActivityFeedParams } from './activityfeed';
import { OperationsForecast, OperationsForecastParams } from './operationsforecast';
import { ServicesDashboard, ServicesDashboardParams } from './servicesdashboard';

export enum Tab {
    Activity,
    Services
}

export interface BerthManagerDashboardParams extends OperationsForecastParams, ActivityFeedParams, ServicesDashboardParams {
    id : number,
    tab : Tab
}

export const BerthManagerDashboard = (params : BerthManagerDashboardParams, ActivityFeed : ActivityFeed, OperationsForecast : (tab : DataSignal<Tab>) => OperationsForecast, ServicesDashboard : ServicesDashboard) => {
    const CurrentTab = S.value(params.tab);

    return { Id : params.id, CurrentTab, ActivityFeed, OperationsForecast: OperationsForecast(CurrentTab), ServicesDashboard };
};
export type BerthManagerDashboard = ReturnType<typeof BerthManagerDashboard>;


// WEBPACK FOOTER //
// ./apps/portcall/berthmgrdashboard/model.ts